import { Component, OnInit, ViewChildren } from '@angular/core';
import { RTEAlertService } from 'rte-library';
import { Entity } from 'src/app/reports/components/entity/entity.model';
import { EntityService } from '../entity.service';
import { ProviderService } from '../../provider/provider.service';
import { SchemaColumn, SchemaForm } from '../../../shared/rte-form/schema/schema.model';
import { Schema } from '../../../shared/rte-form/schema/schema.model';
import { PropertyType } from '../../../shared/rte-form/schema/property-type.enum';
import { ObjectValue } from '../../../models/object-value.model';
import { BaseToolBarCRUDComponent } from 'src/app/reports/shared/utils/base-toolbar-crud.component';
import { assingSchema } from 'src/app/reports/shared/rte-form/schema/schema.helper';
import { permissionToolbar } from 'src/app/reports/helpers/permissiontoolbar';

@Component({
  selector: 'app-entity',
  templateUrl: './entity.component.html',
  styleUrls: ['./entity.component.scss']
})
export class EntityComponent extends BaseToolBarCRUDComponent<Entity> implements OnInit {

  //#region Proprieties

  columns: SchemaColumn[] = [];
  searchForm: SchemaForm;
  saveForm: SchemaForm;

  providerColumn: Schema;
  descriptionColumn: Schema;
  EntityTypeColumn: Schema;

  //#endregion

  //#region Ctor

  constructor(
    public service: EntityService,
    private providerService: ProviderService,
    public alert: RTEAlertService) {
      super(alert);
  }

  //#endregion

  // #regio Interface Implementations

  ngOnInit() {
    permissionToolbar(this.toolbarObject);
    this.toolbarObject.current = new Entity();
    this.toolbarObject.searchObject = new Entity();


    this.setCommonSchemas();
    this.configureColumns();
    this.configureSearchForm();
    this.configureSaveForm();
  }

  configureColumns() {
    this.columns = [
      new SchemaColumn('Código', 'Id'),
      this.descriptionColumn,
      this.providerColumn,
      this.EntityTypeColumn
    ];
  }

  configureSearchForm() {

    this.searchForm = {
      Rows : [
        {
          Columns: [
            this.descriptionColumn,
            this.providerColumn,
          ]
        },
        {
          Columns: [
            this.EntityTypeColumn
          ]
        }
      ]
    };
  }

  configureSaveForm() {

    this.saveForm = {
      Rows : [
        {
          Columns: [
            assingSchema({Required: true}, this.descriptionColumn),
            assingSchema({Required: true}, this.providerColumn),
          ]
        },
        {
          Columns: [
            assingSchema({Required: true}, this.EntityTypeColumn),
          ]
        }
      ]
    };
  }

  private setCommonSchemas() {
    this.descriptionColumn = new Schema('Descrição', 'Description', PropertyType.Text);
    this.providerColumn = new Schema('Provedor', 'Provider.Id', PropertyType.Select);
    this.EntityTypeColumn = new Schema('Tipo', 'EntityType', PropertyType.Select);

    this.loadProviders();
    this.EntityTypeColumn.Values = this.service.getEntityTypeOptions();
  }

  customizeAfterEditMode(edit: boolean) {
    if (edit) {
      this.searchForm.Rows[1].Columns[0].Disabled = true;
      this.saveForm.Rows[1].Columns[0].Disabled = true;
      this.EntityTypeColumn.Disabled = true;
    } else {
      this.searchForm.Rows[1].Columns[0].Disabled = false;
      this.saveForm.Rows[1].Columns[0].Disabled = false;
      this.EntityTypeColumn.Disabled = false;
    }
  }

  //#endregion

  //#region Init Methods

  loadProviders() {
    this.subscription.add(
      this.providerService.getAll().subscribe(result => {
        result.forEach(x => this.providerColumn.Values.push(new ObjectValue(`${x.Name} (${x.ProviderTypeName})`, x.Id)));
      })
    );
  }
  //#endregion
}
